module.exports = __webpack_public_path__ + "img/logo.f972218d.png";